import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import CustomButton from "../../Components/Ui/CustomButton";
import { useScheinContext } from "../../Store/schein-context";

interface CheckPageProps {
  onButtonClick: (page: string) => void;
}

const CheckPage: React.FC<CheckPageProps> = ({ onButtonClick }) => {
  //#region states

  const [isSavingTec, setIsSavingTec] = useState(false);
  const [isSavingCust, setIsSavingCust] = useState(false);

  //#endregion

  const {
    setCustomerSignature,
    setTechnicianSignature,
    technicianSignature,
    customerSignature,
  } = useScheinContext();

  let signCanvasCustomerRef = useRef<SignatureCanvas>(null);
  let signCanvasTechnicianRef = useRef<SignatureCanvas>(null);

  // define canvas size
  const [canvasWidth, setCanvasWidth] = useState(window.innerWidth * 0.75);
  const [canvasHeight, setCanvasHeight] = useState(window.innerHeight * 0.3);

  useEffect(() => {
    const updateCanvasSize = () => {
      setCanvasWidth(window.innerWidth * 0.75); // 80% der Fensterbreite
      setCanvasHeight(window.innerHeight * 0.3); // 30% der Fensterhöhe
    };

    window.addEventListener("resize", updateCanvasSize);
    return () => window.removeEventListener("resize", updateCanvasSize);
  }, []);

  // Customer
  const handleCustomerSignatureCapture = () => {
    if (signCanvasCustomerRef.current?.isEmpty()) {
      alert("Ungültige Unterschrift");
      return;
    }
    const data = signCanvasCustomerRef.current?.toDataURL();
    if (data) {
      setIsSavingCust(true);
      setCustomerSignature(data);
    }
    signCanvasCustomerRef.current?.off();
  };

  const clearCustomerSignature = () => {
    signCanvasCustomerRef.current?.clear();
    setIsSavingCust(false);
    signCanvasCustomerRef.current?.on();
  };

  // Technician
  const handleTechSignatureCapture = () => {
    if (signCanvasTechnicianRef.current?.isEmpty()) {
      alert("Ungültige Unterschrift");
      return;
    }
    const data = signCanvasTechnicianRef.current?.toDataURL();
    if (data) {
      setIsSavingTec(true);
      setTechnicianSignature(data);
    }
    signCanvasTechnicianRef.current?.off();
  };

  const clearTechnicianSignature = () => {
    signCanvasTechnicianRef.current?.clear();
    setIsSavingTec(false);
    signCanvasTechnicianRef.current?.on();
  };

  const checkSignatureStates = () => {
    if (technicianSignature && customerSignature) {
      onButtonClick("finalpage");
    } else {
      alert("Unterschriften überprüfen.");
    }
  };

  return (
    <div>
      <h2 className="text-blue-900 text-xl font-bold p-2">
        Leistungen mit Unterschrift bestätigen
      </h2>

      <div className="w4/4 grid items-center justify-center">
        <div className="inline-grid border border-gray-400 shadow-md rounded-md">
          <SignatureCanvas
            penColor="#000"
            backgroundColor="#FFF"
            ref={signCanvasTechnicianRef}
            canvasProps={{
              width: canvasWidth,
              height: canvasHeight,
              className: "signatureCanvas",
            }}
          />
        </div>
        <div className="w-4/4 flex flex-row items-center justify-between">
          <button
            className="bg-red rounded-md text-white p-1.5 md:p-2 flex items-center justify-center my-5"
            onClick={clearTechnicianSignature}
          >
            Löschen
          </button>
          <span>Unterschrift Techniker</span>

          {!isSavingTec && (
            <>
              <button
                className="bg-lime-600 rounded-md text-white p-1.5 md:p-2 flex items-center justify-center my-5"
                onClick={handleTechSignatureCapture}
              >
                Bestätigen
              </button>
            </>
          )}
          {isSavingTec && (
            <>
              <label className="text-lime-600 mb-0">Gespeichert!</label>
            </>
          )}
        </div>
        <div className="inline-grid border border-gray-400 shadow-md rounded-md">
          <SignatureCanvas
            penColor="#000"
            backgroundColor="#FFF"
            ref={signCanvasCustomerRef}
            canvasProps={{
              width: canvasWidth,
              height: canvasHeight,
              className: "signatureCanvas",
            }}
          />
        </div>
        <div className="w-full flex flex-row items-center justify-between">
          <button
            className="bg-red rounded-md text-white p-1.5 md:p-2 flex items-center justify-center my-5"
            onClick={clearCustomerSignature}
          >
            Löschen
          </button>
          <span>Unterschrift Kunde</span>
          {!isSavingCust && (
            <>
              <button
                className="bg-lime-600 rounded-md text-white p-1.5 md:p-2 flex items-center justify-center my-5"
                onClick={handleCustomerSignatureCapture}
              >
                Bestätigen
              </button>
            </>
          )}
          {isSavingCust && (
            <>
              <label className="text-lime-600 mb-0">Gespeichert!</label>
            </>
          )}
        </div>
        <div className="inline-grid">
          <div className="w-full grid grid-cols-2 gap-4">
            <CustomButton
              className="w-full"
              theme="gray"
              onClick={() => onButtonClick("summary")}
            >
              Zurück
            </CustomButton>

            {isSavingCust && isSavingTec ? (
              <CustomButton
                className="w-full"
                theme="navy"
                onClick={() => checkSignatureStates()}
              >
                Weiter
              </CustomButton>
            ) : (
              // <input
              //   className="w-2/4 bg-blue_navy h-10 p-0 ml-4 rounded-md border-none text-lg text-white cursor-pointer hover:bg-blue-700" // Adjusted for Tailwind's color naming
              //   type="submit"
              //   value="Weiter"
              //   onClick={() => {
              //     checkSignatureStates();
              //   }}
              // />
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckPage;
